export default __webpack_public_path__ + "static/media/empty-chat.e082ae4b.png";